import { createStore } from '@stencil/store';
import { DefaultLanguages } from '../models/DefaultLanguages';

const globalStore = createStore({
  language: DefaultLanguages.de.code,
});

export default globalStore;
